import { GameState } from "../enum/GameState";
import GameObject from "../lib/GameObject";
import MonoBehavior from "../lib/MonoBehavior";
import { Time } from "../lib/Time";
import Transform from "../lib/Transform";
import Vector2 from "../math/Vector2";
import { clamp01 } from "../util";
import Color from "../util/Color";
import GameManager from "./GameManager";

export default class Trail extends MonoBehavior {

    points: {
        position: Vector2;
        time: number;
    }[] = [];
    color = Color.fromHex("#ff0000");

    isDisabled = false;

    LateUpdate(): void {
        if (this.isDisabled) return;
        const lastPt = this.points[this.points.length - 1];

        if (!lastPt) {
            this.points.push({
                position: this.transform.position.clone(),
                time: 1
            });
            return;
        }

        if (Vector2.distance(this.transform.position, lastPt.position) > 4) {
            this.points.push({
                position: this.transform.position.clone(),
                time: 10
            });
        }

        for (let i = this.points.length - 1; i >= 0; i--) {
            const pt = this.points[i];
            pt.time -= Time.deltaTime;

            if (pt.time <= 0) {
                this.points.splice(i, 1);
            }
        }
    }

    Draw(): void {
        if (GameManager.Singleton?.getGameState() !== GameState.InGame) return;
        if (this.points.length < 2) return;

        this.ctx.lineWidth = 1;

        for (let i = 0; i < this.points.length - 1; i++) {
            const pt = this.points[i];
            const next = this.points[i+1];

            if (Vector2.distance(pt.position, next.position) > 16) continue;
            const alpha = clamp01(pt.time/10);
            this.ctx.strokeStyle = this.color.toHexWithAlpha(alpha);
            this.engine.Line(pt.position, next.position);
        }
    }
    
    DrawGizmos(): void {
        this.engine.drawTextsWorldPosition(
            [
                `${this.points.length.toLocaleString()} trail segments`
            ],
            this.transform.position.add(new Vector2(-16, 16)),
            {
                align: 'right',
                color: this.engine.viewport.fColor
            }
        );
    }

}